import { useLangContext } from "../../../../context/langContext";
import AddNewServerForm from "../../../../forms/add-new-server/AddNewServerForm";
import { PbxServerSchema } from "../../../../services/Schemas/PbxServer";
import MuiBaseModal from "../../../common/modal/MuiModal";
import compInfos from "./add-new-server.json";

export interface IAddNewServerModal {
  openModal: boolean;
  onClose: () => void;
  handleReload: () => void;
  serverInfo?: PbxServerSchema;
}

export default function AddNewServerModal({
  handleReload,
  onClose,
  openModal,
  serverInfo,
}: Readonly<IAddNewServerModal>) {

  const { lang } = useLangContext();
  const infos = compInfos[lang];
  return (
    <>
      <MuiBaseModal
        onClose={onClose}
        open={openModal}
        title={!!serverInfo ? infos.title.update : infos.title.create}
        subTitle={!!serverInfo ? infos.subTitle.update : infos.subTitle.create}
        hasCloseIcon
      >
        <AddNewServerForm
          onClose={onClose}
          serverInfo={serverInfo}
          handleReload={handleReload}
        />
      </MuiBaseModal>
    </>
  );
}
